// ConnectionStatus — Broker connection status badge (Angel One light theme)
import React from 'react';
import { useTrading } from '../../../context/TradingContext';

export default function ConnectionStatus() {
  const { connectionStatus, clientcode } = useTrading();

  const configs = {
    connected: { bg: 'bg-green-100', border: 'border-green-300', dot: 'bg-green-500', text: 'text-green-800', label: 'Connected' },
    connecting: { bg: 'bg-yellow-100', border: 'border-yellow-300', dot: 'bg-yellow-500', text: 'text-yellow-800', label: 'Connecting...' },
    disconnected: { bg: 'bg-white/20', border: 'border-white/30', dot: 'bg-gray-400', text: 'text-white/80', label: 'Disconnected' },
    error: { bg: 'bg-red-100', border: 'border-red-300', dot: 'bg-red-500', text: 'text-red-800', label: 'Error' },
  };

  const config = configs[connectionStatus] || configs.disconnected;

  return (
    <div className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full ${config.bg} border ${config.border}`}>
      <div className={`w-1.5 h-1.5 rounded-full ${config.dot} ${connectionStatus === 'connecting' ? 'animate-pulse' : ''}`} />
      <span className={`text-[10px] font-medium ${config.text}`}>
        {config.label}
        {clientcode && connectionStatus === 'connected' ? ` · ${clientcode}` : ''}
      </span>
    </div>
  );
}
